if (!customElements.get('back-in-stock')) {
  class BackInStock extends HTMLElement {
    constructor() {
      super();

      this.popup = this.querySelector('#back-in-stock-popup');
      this.closeButton = this.querySelector('#close-back-in-stock-popup');
      this.openButton = this.querySelector('.trigger-back-in-stock-btn');
      this.form = this.querySelector('.back-in-stock-form');
      this.companyId = 'HvSe36'; // klaviyo company id

      this.openPopup = this.openPopup.bind(this);
      this.closePopup = this.closePopup.bind(this);
      this.formSubmitHandler = this.formSubmitHandler.bind(this);
    }

    connectedCallback() {
      this.openButton.addEventListener('click', this.openPopup);
      this.closeButton.addEventListener('click', this.closePopup);
      this.form.addEventListener('submit', this.formSubmitHandler);
    }

    disconnectedCallback() {
      // Clean up event listeners if needed
      this.openButton.removeEventListener('click', this.openPopup);
      this.closeButton.removeEventListener('click', this.closePopup);
      this.form.removeEventListener('submit', this.formSubmitHandler);
    }

    // Open popup
    openPopup() {
      this.popup.showModal();
    }

    closePopup() {
      this.popup.close();
    }

    formSubmitHandler(event) {
      event.preventDefault();

      const email = this.form.email.value.trim();
      const variantId = this.form.querySelector('input[name="id"]').value.trim();

      if (!email || !variantId) {
        alert('Please enter a valid email and variant ID.');
        return;
      }
      // Prepare the payload
      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantId}`,
              },
            },
          },
        },
      };

      var requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-06-15',
        },
        body: JSON.stringify(payload),
      };
      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.companyId}`, requestOptions)
        .then((result) => {
          // Check for 202 Accepted
          if (result.status === 202) {
            // Show success message
            this.form.reset(); // Reset the form
            const successMessage = this.form.querySelector('.back-in-stock-success-msg');
            successMessage.style.display = 'block';

            // Hide popup after 2 seconds
            setTimeout(() => {
              successMessage.style.display = 'none';
              this.popup.close();
            }, 2000);
          } else {
            alert('Something went wrong. Please try again Later.');
          }
        })
        .catch((error) => {
          alert('Something went wrong. Please try again Later.');
        });
    }
  }
  customElements.define('back-in-stock', BackInStock);
}
